import script from "./SucaiDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SucaiDetail.vue?vue&type=script&setup=true&lang=js"

import "./SucaiDetail.vue?vue&type=style&index=0&id=20ed40ac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ed40ac"]])

export default __exports__